let pageReady = false;
window.addEventListener("load", () => {
  document.body.classList.add("transitions-ready");

  const background = document.querySelector('.mega-menu__background');
  if (!background) return;

  document.querySelectorAll('ul.list-menu').forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      background.classList.add('is-hovering');
    });
    menu.addEventListener('mouseleave', () => {
      background.classList.remove('is-hovering');
    });
  });
});

window.addEventListener('load', function() {
  var bg = document.querySelector('.mega-menu__background');
  if (bg) {
    bg.classList.remove('is-hidden');
  }
});


class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.detailsElement = this.querySelector("details");
    this.summaryElement = this.detailsElement?.querySelector("summary");
    this.megaMenuContent = this.querySelector(".mega-menu__content");
    this.background = document.querySelector('.mega-menu__background');

    if (!this.detailsElement || !this.summaryElement || !this.megaMenuContent) return;

    window.addEventListener("load", () => {
      this.megaMenuContent.classList.add("transitions-ready");

      this.summaryElement.addEventListener("mouseenter", () => {
        this.openMenu();
        this.setBackgroundHeight();
      });

      this.detailsElement.addEventListener("mouseleave", () => {
        this.closeMenu();
        this.resetBackgroundHeight();
      });
    });
  }

  setBackgroundHeight() {
    if (this.background && this.megaMenuContent) {
      const left = this.megaMenuContent.querySelector('.mega-menu__left');
      const images = this.megaMenuContent.querySelector('.mega-menu--images');
      let maxHeight = 0;
      if (left) maxHeight = left.getBoundingClientRect().height;
      if (images) {
        const imagesHeight = images.getBoundingClientRect().height;
        if (imagesHeight > maxHeight) maxHeight = imagesHeight;
      }
      if (maxHeight === 0) maxHeight = this.megaMenuContent.getBoundingClientRect().height;
      maxHeight += 60; // Add 30px padding to the background height
      this.background.style.height = maxHeight + 'px';
    }
  }

  resetBackgroundHeight() {
    if (this.background) {
      this.background.style.height = null;
    }
  }

  openMenu() {
    if (!this.detailsElement.open) {
      this.detailsElement.open = true;
    }

    this.megaMenuContent.classList.remove("mega-menu__content--visible");
    void this.megaMenuContent.offsetHeight;
    this.megaMenuContent.classList.add("mega-menu__content--visible");

    // Wait for the next animation frame to ensure layout is updated
    requestAnimationFrame(() => {
      this.setBackgroundHeight();
      // Then, try again after a short delay to catch late layout/image loads
      setTimeout(() => {
        this.setBackgroundHeight();
      }, 60);
    });
  }

  closeMenu() {
    this.megaMenuContent.classList.remove("mega-menu__content--visible");
    this.resetBackgroundHeight();

    setTimeout(() => {
      if (this.detailsElement.open) {
        this.detailsElement.open = false;
      }
    }, 400);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") !== ""
    )
      return;

    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);